import React from 'react'
import SectionHeader from './SectionHeader'

const testimonials = [
  {
    name: 'Ben Domey',
    role: 'Business Operations Lead',
    quote:
      'Whistle Pulse gave our team a dependable way to reach customers quickly. The dashboard is simple, the delivery visibility is clear, and the support has been excellent.',
  },
  {
    name: 'Samuel Young Appiah',
    role: 'Product Manager',
    quote:
      'The API was easy to connect to our workflow. We were able to send OTPs and customer updates without slowing down our development team.',
  },
  {
    name: 'Frederick Larsey',
    role: 'Growth and Partnerships',
    quote:
      'For campaign messaging, Whistle Pulse has been reliable and straightforward. It helps us communicate at scale while keeping the process organized.',
  },
  {
    name: 'Tony Tony',
    role: 'Customer Experience Lead',
    quote:
      'What stood out for us was the consistency. Messages go out fast, reporting is easy to follow, and the platform feels built for real business use.',
  },
]

const StarRating = () => (
  <div className="flex gap-1 text-[#ffc94d]" aria-label="Five star rating">
    {[...Array(5)].map((_, index) => (
      <svg
        key={index}
        className="h-5 w-5"
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg>
    ))}
  </div>
)

const Testimonials = () => {
  return (
    <section className="bg-[#f3f9ff]">
      <div className="mx-auto max-w-[85rem] px-4 py-14 sm:px-6 lg:px-8 lg:py-28">
        <SectionHeader
          firstLine="Trusted by teams"
          secondLine=""
          thirdLine="building better communication."
          subtitle="Customer feedback from teams using Whistle Pulse for business messaging, OTPs, and customer updates."
        />

        <div className="mt-10 grid gap-5 md:grid-cols-2 xl:grid-cols-4">
          {testimonials.map((testimonial, index) => (
            <blockquote
              key={testimonial.name}
              className="group flex h-full flex-col justify-between rounded-2xl border border-blue-100 bg-white p-6 shadow-sm transition duration-300 hover:-translate-y-1 hover:border-blue-200 hover:shadow-xl hover:shadow-blue-100/60 sm:p-7 wow animate__animated animate__fadeInUp"
              data-wow-delay={`.${index + 2}s`}
            >
              <div>
                <StarRating />
                <p className="mt-6 text-lg font-semibold leading-8 text-[#040051]">"{testimonial.quote}"</p>
              </div>

              <footer className="mt-8 border-t border-blue-50 pt-5">
                <p className="font-bold text-gray-900">{testimonial.name}</p>
                <p className="mt-1 text-sm font-medium text-blue-500">{testimonial.role}</p>
              </footer>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Testimonials
